const SELL_STATUSES = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  PENDING: 'pending',
}

module.exports = { SELL_STATUSES }
